/* eslint-disable prettier/prettier */
import * as yup from 'yup'
// no country prefix valid regex ^[0]{1}[1]{1}[0]{1}[0-9]{3,4}[0-9]{4}$
// Regex for country prefix ^[8]{1}[2]{1}[1]{1}[0]{1}[0-9]{8}$
// Regex starting 0 ^[0]{1}[0-9]{2}[0-9]{3,4}[0-9]{4}$
const phoneNumberValidationRegex = /^[0]{1}[0-9]{2}[0-9]{3,4}[0-9]{4}$/
const nameValidationRegex = /^\S*[a-zA-Z\s\u3131-\uD79D]+\S$/

const schemaValidation = (optQuestions) => {

    const optionalQuestions = optQuestions && optQuestions?.reduce((acc, question) => {
            acc[question] = yup.string().required()
            return acc
        }, {})

    return yup
        .object({
            consentCollectPersonalInformation: yup.boolean().oneOf([true]).required(),
            consentMarketing: yup.boolean().oneOf([true]).required(),
            consentAdvertising: yup.boolean().oneOf([true]).required(),
            name: yup.string().matches(nameValidationRegex).required(),
            phone_number: yup
                .string()
                .min(8)
                .max(11)
                .matches(phoneNumberValidationRegex)
                .required(),
            gender: yup.string().required(),
            region: yup.string().required(),
            birthday: yup.string().min(8).max(8).required(),
            ...optionalQuestions,
            contact: yup.string().required(),
        })
        .required()
}

export default schemaValidation
